module.exports = __webpack_public_path__ + "media/assets/icons/graph-2df420d24e69ee34eab53fa07df2e031.svg";